import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { helpCenterSettingsAgentStudioChatSimulatorRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsAgentStudioChatSimulatorRoute.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { ChatSimulatorLoadingState } from '@atlassian/csm-chat-simulator/loading-state';
import { agentStudioNavigation } from './common/constants.tsx';

import {
	LazyAgentStudioSimulatorPage,
	AgentStudioSimulatorComponent,
} from './ui/agent-studio/index.tsx';

export const helpCenterSettingsAgentStudioChatSimulatorRouteEntry = createEntry(
	helpCenterSettingsAgentStudioChatSimulatorRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.agent-studio-chat-simulator',
		component: componentWithFG(
			'enable_support_center_agent_studio_page',
			AgentStudioSimulatorComponent,
			ErrorPagesNotFound,
		),
		skeleton: ChatSimulatorLoadingState,
		layout: serviceProjectLayout,
		navigation: agentStudioNavigation,
		resources: [...getServiceDeskSettingsResources()],
		forPaint: [LazyAtlassianNavigation, LazyAgentStudioSimulatorPage],
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	}),
);
